import React from 'react';
import { ModalOverlay as OmModalOverlay, ModalOverlayProps } from '@moda/om';
import { getModalShards } from './getModalShards';

export { ModalOverlayProps };

export const ModalOverlay: React.FC<ModalOverlayProps> = ({ shards, ...rest }) => (
  <OmModalOverlay shards={[...getModalShards(), ...(shards ?? [])]} {...rest} />
);
